import axios from 'axios';

const LOCAL_API = 'http://localhost:8080';
const PROD_API = 'https://polls-service-6qrvcljmeq-uc.a.run.app';

export const primaryApiUrl =
  process.env.NODE_ENV === 'production' ? PROD_API : LOCAL_API;

// Prefer the local Django backend in development; if it is down, load
// gallery data from the live Cloud Run service so local preview still works.
export const fetchApi = (path) =>
  axios.get(`${primaryApiUrl}${path}`).catch((error) => {
    if (primaryApiUrl !== PROD_API) {
      return axios.get(`${PROD_API}${path}`);
    }
    throw error;
  });
